<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import TransporterSelectControl from "../components/controls/TransporterSelectControl.svelte";


    export let taxiId = null;
    export let closeCallback;

    let taxi = null;

    const initialize = () => {
        if (taxiId == 0) {
            taxi = {
                id: 0,
                transporter_id: '0',
                taxi_number: '',
                licence_no: '',
                is_active: 1,
            }
            setFocusTo('taxiNumber');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            taxi = result;
            setFocusTo('taxiNumber');
        };

        const onFailure = err => {
        };

        R.handle(R.taxi.details, taxiId, onSuccess, onFailure, LOADER.POPUP);
    };

    const close = (param) => {
        taxi = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }


    const save = () => {
        const onSuccess = result => {
            close(result);
        }

        const onFailure = err => {
        };

        taxi.taxi_number = taxi.taxi_number.trim();
        if (!taxi.taxi_number) {
            Notifier.showError("Enter the Taxi number!");
            setFocusTo("taxiNumber");
            return;
        }
        taxi.licence_no = taxi.licence_no.trim();
        if (!taxi.licence_no) {
            Notifier.showError("Enter the Taxi licence number!");
            setFocusTo("licenceNumber");
            return;
        }

        // taxi.transporter_id = transporter ? transporter.id : 0;
        if (taxi.transporter_id == 0) {
            Notifier.showError("No transport company selected!");
            setFocusTo("transporter");
            return;
        }

        let action = taxiId == 0 ? 'create' : 'edit';
        R.handle(R.taxi[action], taxi, onSuccess, onFailure, LOADER.POPUP);
    }

    initialize();

</script>

{#if taxi}
    <Modal title="Taxi" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Taxi Number</label>
                <input type="text" class="form-control" id="taxiNumber" bind:value="{ taxi.taxi_number }">
            </div>
            <div class="form-group">
                <label>Licence Number</label>
                <input type="text" class="form-control" id="licenceNumber" bind:value="{ taxi.licence_no }">
            </div>
            <div class="form-group mb-4">
                <label>Transport Company</label>
                <TransporterSelectControl id="transporter" bind:transporterId={taxi.transporter_id}
                                          placeholder="select transport company"/>
            </div>
            <div class="form-group">
                <Checkbox label="Active taxi" bind:checked={ taxi.is_active }/>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Save</button>
            </div>
        </div>
    </Modal>
{/if}